import { services as mockServices, references as mockReferences, whyUs as mockWhyUs, workflow as mockWorkflow } from '../data';

const BASE_URL = 'https://api.dev.auxo.dk/public/v2/content';

export function extractLang(val, lang = 'da') {
  if (val === null || val === undefined) return '';
  if (typeof val === 'string' || typeof val === 'number') return String(val);
  if (typeof val === 'object') {
    return val[lang] || val.da || val.en || Object.values(val)[0] || '';
  }
  return '';
}

export function extractArray(val) {
  if (!val) return [];
  if (Array.isArray(val)) return val;
  if (typeof val === 'string') {
    return val.split(/\r?\n|,/).map(s => s.trim()).filter(Boolean);
  }
  if (typeof val === 'object') {
    const list = extractLang(val);
    if (Array.isArray(list)) return list;
    if (typeof list === 'string') return list.split(/\r?\n|,/).map(s => s.trim()).filter(Boolean);
  }
  return [];
}

export function extractImage(imgField) {
  if (!imgField) return '';
  if (Array.isArray(imgField) && imgField.length > 0) return imgField[0];
  if (typeof imgField === 'string') return imgField;
  return '';
}

export async function fetchCmsCollection(collectionName, fallbackData = []) {
  try {
    const res = await fetch(`${BASE_URL}/${collectionName}`);
    if (!res.ok) throw new Error(`HTTP error! status: ${res.status}`);
    const data = await res.json();
    const items = Array.isArray(data) ? data : (data.items || []);
    if (!items || items.length === 0) return fallbackData;
    return items;
  } catch (err) {
    console.warn(`CMS fetch failed for ${collectionName}, using fallback data`, err);
    return fallbackData;
  }
}

export function normalizeService(item) {
  return {
    title: extractLang(item.title),
    description: extractLang(item.description),
    icon: item.icon || 'Briefcase',
    order: item.order || 0
  };
}

export function normalizeReference(item) {
  const slugVal = typeof item.slug === 'object' ? extractLang(item.slug) : (item.slug || '');
  return {
    id: item.id,
    slug: slugVal,
    company: item.company || '',
    title: extractLang(item.title),
    description: extractLang(item.description),
    fullDescription: extractLang(item.full_description || item.fullDescription),
    keyResults: extractArray(item.key_results || item.keyResults),
    technologies: extractArray(item.technologies),
    image: extractImage(item.image)
  };
}

export function normalizeWhyUs(item) {
  return {
    title: extractLang(item.title),
    description: extractLang(item.description),
    icon: item.icon || 'ShieldCheck',
    order: item.order || 0
  };
}

export function normalizeWorkflow(item) {
  return {
    step: item.step || '',
    title: extractLang(item.title),
    description: extractLang(item.description),
    order: item.order || 0
  };
}
